export const detectUrl = (text: string) => {
  const links = text.match(
    new RegExp("(http|https)://([\\w_-]+(?:(?:\\.[\\w_-]+)+))([\\w.,@?^=%&:/~+#-]*[\\w@?^=%&/~+#-])?")
  );
  return links || [];
};
